export default __webpack_public_path__ + "static/media/kin-home-logo.2977f1c4.png";